import { render } from "./ClinicLayout.vue?vue&type=template&id=769debca"
import script from "./ClinicLayout.vue?vue&type=script&lang=js"
export * from "./ClinicLayout.vue?vue&type=script&lang=js"

import "./ClinicLayout.vue?vue&type=style&index=0&id=769debca&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__